import Accordions4i from '../../common/accordions25.js';

async function init() {
    const accordions = new Accordions4i();
    await accordions.init(document.querySelector("#mainContent"));		
    document.addEventListener("click", events);
}

async function events(e){
    if (e.target.classList.contains("videoLink")) {
        e.preventDefault();
        const videoDialog = await loadVideoJS();
        if(!videoDialog) return;
        videoDialog.open(e, e.target);
    }
}

let videoPromise = null;
async function loadVideoJS(){
    if(videoPromise){ return videoPromise; }
	try {
		videoPromise = await import('../../common/videos/videodialog.js');
        videoPromise.default.init();
		return videoPromise.default; // Return the default export
	} catch (error) {
		console.error("Error in loadVideoJS. Failed to load video module:", error);
		videoPromise = null; // Reset to allow retry on failure
		return null;
	}
}

await init();